import { v4 as uuidv4 } from "uuid";

export const percentage = (partialValue, totalValue) => {
  return (100 * partialValue) / totalValue;
};
export function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const getPlatformValue = (type, subtype) => {
  if (subtype.depopLevel) return subtype.depopLevel;
  if (subtype.stockLevel) return subtype.stockLevel;
  if (subtype.goatLevel) return subtype.goatLevel;
  return type;
};

export const setPlatformValue = (type) => {
  switch (type) {
    case "Extra small (under 4oz)":
    case "Small (under 8oz)":
    case "Medium (under 1lb)":
    case "Large (under 2lb)":
    case "Xtra Large (under 10lb)":
      return { serviceProviders: "Depop", depopLevel: type };

    case "Level 1":
    case "Level 2":
    case "Level 3":
    case "Level 4":
    case "Level 5":
      return { serviceProviders: "StockX", stockLevel: type };

    case "90-100":
    case "70-89":
    case "50-69":
      return { serviceProviders: "GOAT", goatLevel: type };

    default:
      return { serviceProviders: type };
  }
};

export const InitialCalcPlatform = [
  {
    value: "Etsy",
    label: "Etsy",
  },
  {
    value: "Poshmark",
    label: "Poshmark",
  },
  {
    value: "Depop",
    label: "Depop",
    subOption: [
      {
        value: "Extra small (under 4oz)",
        label: "Extra small (under 4oz)",
      },
      {
        value: "Small (under 8oz)",
        label: "Small (under 8oz)",
      },
      {
        value: "Medium (under 1lb)",
        label: "Medium (under 1lb)",
      },
      {
        value: "Large (under 2lb)",
        label: "Large (under 2lb)",
      },
      {
        value: "Xtra Large (under 10lb)",
        label: "Xtra Large (under 10lb)",
      },
    ],
  },
  {
    value: "Shopify",
    label: "Shopify",
  },
  {
    value: "StockX",
    label: "StockX",
    subOption: [
      {
        value: "Level 1",
        label: "Level 1",
      },
      {
        value: "Level 2",
        label: "Level 2",
      },
      {
        value: "Level 3",
        label: "Level 3",
      },
      {
        value: "Level 4",
        label: "Level 4",
      },
      {
        value: "Level 5",
        label: "Level 5",
      },
    ],
  },
  {
    value: "Mercari",
    label: "Mercari",
  },
  {
    value: "GOAT",
    label: "GOAT",
    subOption: [
      {
        value: "90-100",
        label: "90-100",
      },
      {
        value: "70-89",
        label: "70-89",
      },
      {
        value: "50-69",
        label: "50-69",
      },
    ],
  },
  {
    value: "Vinted",
    label: "Vinted",
  },
  {
    value: "OfferUp",
    label: "OfferUp",
  },
  {
    value: "Grailed",
    label: "Grailed",
  },
  {
    value: "Instagram/Facebook Marketplace",
    label: "Instagram/Facebook Marketplace",
  },
  {
    value: "Custom",
    label: "Custom",
  },
];

export const InitialState = {
  listingPrice: "",
  valueOfEachHour: "",
  timeYouSpend: { value: "", time: "hours" },
  activity: [],
  materials: "",
  shipping: "",
  serviceProviders: "",
  transactionFee: "",
  creditCardFee: "",
  profit: "",
  listingFee: "",
  lcost: "",
  depopFee: "",
  depopShippingLabelFee: "",
  commissionFee: "",
  stockLevel: "",
  depopLevel: "",
  goatLevel: "",
  averagePerHour: "",
  netProfit: "",
  netProfitMargin: "",
  isEdit: false,
  marketplaces: "",
  calcName: "",
  topThreeVal: [],
  paymentProcessing: "",
  selling: "",
  serviceFee: "",
  otherFee: "",
};

export const InitialErrorState = {
  calculatorTypeError: false,
  listingPriceError: false,
  valueOfEachHourError: false,
  timeYouSpend: { valueError: false, timeError: false },
  materialsError: false,
  shippingError: false,
  serviceProvidersError: false,
  transactionFeeError: false,
  creditCardFeeError: false,
  profitError: false,
  listingFeeError: false,
  depopFeeError: false,
  depopShippingLabelFeeError: false,
  commissionFeeError: false,
  marketplacesError: false,
};

export const getCalcType = (calculatorType) => {
  switch (calculatorType) {
    case "calc-1":
      return "Profit";
    case "calc-2":
      return "Listing Price";
    case "calc-3":
      return "Labor Value";
    case "calc-4":
      return "Wage per Hour";
    case "calc-5":
      return "Profit Margin";
  }
};

export const apiToLocalObject = (apiObj) => {
  const activityArray = [] as any;
  if (apiObj.timeBreakName.length > 0) {
    apiObj.timeBreakName.forEach((data, i) => {
      activityArray.push({
        value: apiObj.timeBreakTime[i],
        time: apiObj.timeBreakSelect[i],
        name: apiObj.timeBreakName[i],
        id: uuidv4(),
      });
    });
  }

  return {
    ...InitialState,
    listingPrice: apiObj.listing,
    profit: apiObj.profit,
    netProfit: apiObj.profit,
    valueOfEachHour: apiObj.timeValue,
    timeYouSpend: {
      value: apiObj.timeSpent,
      time: apiObj.timeSelect,
    },
    activity: activityArray,
    commissionFee: apiObj.commissionFee,
    depopShippingLabelFee: apiObj.depopShippingLabelFee,
    depopFee: apiObj.depopFee,
    materials: apiObj.matCost,
    shipping: apiObj.shipCost,
    listingFee: apiObj.listFee,
    transactionFee: apiObj.transactFee,
    creditCardFee: apiObj.credCardFee,
    calcName: apiObj.name,
    paymentProcessing: apiObj.paymentProcessing || 0,
    selling: apiObj.selling || 0,
    serviceFee: apiObj.serviceFee,
    ...setPlatformValue(apiObj.platform),
  };
};

export const localToApiObject = (data) => {
  const timeBreakValidData = data.activity?.filter((d) => d.name);
  const timeBreakName = timeBreakValidData.length
    ? data.activity?.map((d) => d.name)
    : [];
  const timeBreakTime = timeBreakValidData.length
    ? data.activity?.map((d) => +d.value)
    : [];
  const timeBreakSelect =
    timeBreakName.length || timeBreakTime.length
      ? timeBreakValidData
        ? data.activity?.map((d) => d.time)
        : []
      : [];

  return {
    listing: +data.listingPrice,
    profit: +data.profit,
    timeValue: +data.valueOfEachHour,
    timeSpent: +data.timeYouSpend.value,
    timeSelect: data.timeYouSpend.time,
    timeBreakName,
    timeBreakTime,
    timeBreakSelect,
    platform: getPlatformValue(data.serviceProviders, {
      depopLevel: data.depopLevel,
      stockLevel: data.stockLevel,
      goatLevel: data.goatLevel,
    }),
    marketplaces: data.marketplaces,
    matCost: +data.materials,
    shipCost: +data.shipping,
    listFee: +data.listingFee,
    transactFee: +data.transactionFee,
    credCardFee: +data.creditCardFee,
    commissionFee: +data.commissionFee,
    depopShippingLabelFee: +data.depopShippingLabelFee,
    depopFee: +data.depopFee,
    paymentProcessing: +data.paymentProcessing,
    selling: +data.selling,
    serviceFee: +data.serviceFee,
  };
};
